export const EXHIBITION_SUBCATEGORIES = `
  query exhibitionSubcategories($filter: FilterExhibitionSubcategoryInput, $tenant_id: Int!) {
    exhibitionSubcategories(filter: $filter, tenant_id: $tenant_id) {
      __typename

      ... on ExhibitionSubcategory {
        id
        name
        exhibition_category_id
        category {
          id
          name
        }
        tag
        is_active
        vistage20_id
        its
        uts
        dts
        created_by
        updated_by
        deleted_by
      }

      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const EXHIBITION_SUBCATEGORIES_BY_CATEGORY = `
  query exhibitionSubcategoriesByCategory($categoryId: Int!, $tenant_id: Int!) {
    exhibitionSubcategoriesByCategory(categoryId: $categoryId, tenant_id: $tenant_id) {
      __typename

      ... on ExhibitionSubcategory {
        id
        name
        exhibition_category_id
        category {
          id
          name
        }
        tag
        is_active
        vistage20_id
        its
        uts
        dts
        created_by
        updated_by
        deleted_by
      }

      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const EXHIBITION_SUBCATEGORY = `
  query exhibitionSubcategory($id: Int!, $tenant_id: Int!) {
    exhibitionSubcategory(id: $id, tenant_id: $tenant_id) {
      __typename

      ... on ExhibitionSubcategory {
        id
        name
        exhibition_category_id
        category {
          id
          name
        }
        tag
        is_active
        vistage20_id
        its
        uts
        dts
        created_by
        updated_by
        deleted_by
      }

      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;
